import { PInlineNotification } from "@porsche-design-system/components-react"
import { defineMessages, FormattedMessage } from "react-intl"

const messages = defineMessages({
	campaignsNotYetAvailableHint: {
		defaultMessage: "There might be open campaigns, please try again later.",
		id: "vehicleDetails.overview.campaigns.notYetAvailableHint",
	},
})

interface UnknownCampaignsWarningProps {
	error?: string
}

export const UnknownCampaignsWarning = ({ error }: UnknownCampaignsWarningProps) => (
	<PInlineNotification state="warning" dismissButton={false}>
		{error ?? <FormattedMessage {...messages.campaignsNotYetAvailableHint} />}
	</PInlineNotification>
)
